<template>
    <div class="q-input" @click="handleClick" :disabled="disabled">
        <span class="prefix" v-if="prefix"> {{ prefix }} </span>
        <slot name="prefix"></slot>
        <input v-if="type === 'input'"
               ref="inputRef"
               :type="inputType"
               :pattern="inputType === 'tel' ? '\d*' : ''"
               class="input"
               v-model="curValue"
               @focus="inputFocus"
               @blur="inputBlur"
               :placeholder="placeholder"
               :maxlength="maxLength"
               @input="onInput" />
        <!-- <input v-if="type === 'input'" ref="inputRef" class="input" v-model="curValue" @focus="inputFocus" @blur="inputBlur" :placeholder="placeholder" :maxlength="maxLength" @input="onInput" /> -->
        <textarea v-if="type === 'textarea'" ref="inputRef" class="input-textarea" v-model="curValue" @focus="inputFocus" @blur="inputBlur" :placeholder="placeholder" :maxlength="maxLength" />

        <span class="suffix" v-if="suffix"> {{ suffix }} </span>
        <slot name="suffix"></slot>

        <div class="highlight" v-if="highlight">{{ highlight }}</div>
        <slot name="highlight"></slot>

        <span v-if="ifFocus && curValue" class="close" @click="clearInput" @mousedown.prevent></span>
    </div>
</template>

<script lang="ts" setup>
import { ref, watch, toRaw, onMounted } from 'vue';
// import { regxMap } from '../../assets/ts/const';
const props = defineProps({
    value: {
        type: String,
        required: true,
    },
    keyStr: {
        type: String,
        default: '',
    },
    prefix: {
        type: String,
        default: '',
    },
    suffix: {
        type: String,
        default: '',
    },
    highlight: {
        type: String,
        default: '',
    },
    type: {
        type: String,
        default: 'input',
    },
    placeholder: {
        type: String,
        default: '',
    },
    maxLength: {
        type: [String, Number],
        default: '',
    },
    valueType: {
        type: String, // number | idcard
    },
    inputType: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['change', 'click', 'input', 'blur', 'focus']);

const curValue = ref(props.value);
watch(
    () => curValue.value,
    (newValue) => {
        emit('change', [newValue, props.keyStr]);
    },
    { deep: true, }
);
watch(
    () => props.value,
    (newValue) => {
        curValue.value = newValue;
    },
    { deep: true, }
);

const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    emit('click');
};

const inputRef = ref();
const ifFocus = ref(false);
const inputFocus = () => {
    emit('focus');
    if (props.keyStr === 'location') {
        inputRef.value.blur();
    } else {
        ifFocus.value = true;
    }
};
const inputBlur = () => {
    emit('blur');
    ifFocus.value = false;
};
const clearInput = () => {
    curValue.value = '';
    emit('input', '');
};

const onInput = (e) => {
    emit('input', e.target.value);
    // if (props.valueType && regxMap[props.valueType]) {
    //     curValue.value = e.target.value.replace(regxMap[props.valueType], '');
    // }
};

onMounted(() => {
    if (props.type === 'textarea') {
        inputRef.value.addEventListener('input', () => {
            inputRef.value.style.height = 'auto'; // 重置高度
            inputRef.value.style.height = inputRef.value.scrollHeight + 'px'; // 根据内容调整高度
        });

        // TODO 滚动页面至输入框
        inputRef.value.addEventListener('focus', () => {
            setTimeout(() => {
                inputRef.value.scrollIntoView(false);
            }, 300);
        });
    }
});
</script>

<style lang="scss" scoped>
.q-input {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    background: rgba(254,244,212,0.6);
    border-radius: 32px;
    border: 0.5px solid #F2B87C;
    overflow: hidden;
    padding: 0 12px;
    &[disabled] {
        // border-color: rgba(242,184,124,0.3) !important;
        opacity: 0.4;
        &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            // background: rgba(0,0,0,0.1) !important;
        }
    }
    .highlight {
        position: absolute;
        left: 84px;
        top: 76px;
        font-size: 20px;
        color: #ff4a25;
    }

    .prefix {
        margin-right: 32px;
    }

    .suffix {
        margin-right: 24px;
    }
    .close {
        position: absolute;
        right: 16px;
        width: 40px;
        height: 40px;
        background: url('../assets/images/icon-clear.png') no-repeat center center;
        background-size: 100% 100%;
    }
    .input {
        flex: 1;
        font-size: 28px;
        display: block;
        height: 100%;
        color: #994E00;
        caret-color: #994E00;
        background: transparent;
        min-width: 10px;
        &::-webkit-input-placeholder {
            color: rgba(153,78,0,0.4);
            font-size: 24px;
        }
    }
    .input-textarea {
        padding: 32px 0;
        width: 100%;
        min-height: 144px;
        font-size: 28px;
        line-height: 34px;
        resize: none;
        overflow: hidden;
        caret-color: #fca000;
    }
}
</style>
